(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/account.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/account.js');

'use strict';

const {
  createQueryString,
  setURLParams
} = svs.tur.payment.utils.misc;
const {
  checkAndShowSyndicateTermsDialog
} = svs.syndicate.rules_and_terms;
class Account {
  constructor() {
    let {
      syndicate,
      returnParams,
      onCancel
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.syndicate = syndicate;
    this.returnParams = returnParams;
    this.onCancel = onCancel;
  }
  checkStatus(_ref) {
    let {
      price
    } = _ref;
    const deferred = $.Deferred();
    if (!this._isUserLoggedIn()) {
      setURLParams(this.returnParams);
      svs.components.customer_login.login({
        returnNewCustomer: true
      });
      return deferred.reject();
    }
    if (this._isUserBlocked()) {
      svs.accountservices.national_suspension_message.showNationalSuspensionPayMessage();
      return deferred.reject();
    }
    if (this._hasDayTimeLimitExpired()) {
      this._showDayTimeLimitInfo();
      return deferred.reject();
    }
    if (this.isSyndicateAccount()) {
      checkAndShowSyndicateTermsDialog();
    }
    this._accountBalance().done(() => {
      if (this._canAffordPayment({
        price
      })) {
        deferred.resolve();
      } else {
        this._showUserLowBalanceDialog({
          price
        });
        deferred.reject();
      }
    }).fail(() => deferred.reject());
    return deferred;
  }
  _isUserLoggedIn() {
    return svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  }
  isSyndicateAccount() {
    return this.syndicate;
  }
  _isUserBlocked() {
    return svs.core.userSession.isBlocked();
  }
  _hasDayTimeLimitExpired() {
    return svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dayTimeLimit && svs.day_time_limit.data.dayTimeLimit.dayTimeExpired;
  }
  _showDayTimeLimitInfo() {
    svs && svs.accountservices && svs.accountservices.day_time_limit && svs.accountservices.day_time_limit.notices && svs.accountservices.day_time_limit.notices.pay();
  }
  _canAffordPayment(_ref2) {
    let {
      price
    } = _ref2;
    const balance = this.balance.replace(/\s*/g, '');
    return parseInt(balance, 10) >= price;
  }
  _accountBalance() {
    const deferred = $.Deferred();
    if (this.isSyndicateAccount()) {
      let syndicateModel;
      if (this.syndicate) {
        let syndicateCollection = svs.syndicate.core.collections.getSyndicateCollectionInstance();
        if (!syndicateCollection.length) {
          syndicateCollection = svs.syndicate.core.collections.getSyndicateCollectionInstance().reset(svs.syndicate.account_selector.data.syndicates, {
            parse: true
          });
        }
        syndicateModel = syndicateCollection.find(m => m.get('syndicateId') === this.syndicate.syndicateId);
      }
      this.balance = syndicateModel.get('playableAmount');
      deferred.resolve(this.balance);
    } else {
      svs.components.account_balance.get(balance => {
        this.balance = balance;
        deferred.resolve(this.balance);
      });
    }
    return deferred;
  }
  _showUserLowBalanceDialog(_ref3) {
    var _this$syndicate, _this$syndicate2;
    let {
      price
    } = _ref3;
    svs.tur.payment.logger.info("Not enough money. Price: ".concat(price, ", balance: ").concat(this.balance, ", syndicateId: ").concat((_this$syndicate = this.syndicate) === null || _this$syndicate === void 0 ? void 0 : _this$syndicate.syndicateId));
    new svs.tur.payment.dialogs.UserLowBalance({
      price,
      balance: this.balance,
      isSyndicate: Boolean((_this$syndicate2 = this.syndicate) === null || _this$syndicate2 === void 0 ? void 0 : _this$syndicate2.syndicateId),
      returnUrl: "".concat(window.location.href).concat(createQueryString(this.returnParams)),
      onCancel: this.onCancel
    });
  }
}
svs.tur.payment.services.Account = Account;

 })(window);